import moment from "moment";
import { __ } from "WebsiteApp";
import i18n from "WebsiteApp/i18n";

export function date(dateValue, format = "D/M/Y") {
  return moment(dateValue).format(format);
}
export function time(dateValue, format = "HH:mm") {
  return moment(dateValue).format(format);
}

export function getHumanized(dateValue) {
  return date(dateValue, "ddd, MMM Do");
}

export function add(date, count, intervals) {
  if (date == null) {
    date = moment();
  }
  return moment(date).add(count, intervals);
}

export function year(date = null) {
  if (!date) {
    return moment().year();
  }

  return moment(date).year();
}

export function expiryDate(dateValue) {
  return date(dateValue, "MM/YYYY");
}

export function toApiDate(dateValue, fromFormat = "DD/MM/YYYY") {
  return moment(dateValue, fromFormat).format("YYYY-MM-DD");
}

/**
 * TODO: Return greeting by time
 */
export function getGreeting() {
  let today = new Date();
  let curHr = today.getHours();

  if (curHr < 12) {
    return i18n.t("Good morning");
  } else if (curHr < 18) {
    return i18n.t("Good afternoon");
  } else {
    return i18n.t("Good evening");
  }
}

export function getCurrentHoursInUk() {
  const options = {
    timeZone: "Europe/London",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  };
  const ukDateFormatter = new Intl.DateTimeFormat("en-GB", options);

  // Get the current date and time in the UK time zone
  const ukDate = new Date();
  const ukTime = ukDateFormatter.format(ukDate);

  // Extract the hours from the UK time
  return parseInt(ukTime.split(":")[0]);
}

export default {
  date,
  time,
  getHumanized,
  add,
  expiryDate,
  toApiDate,
  getGreeting,
  year,
  getCurrentHoursInUk
};



// WEBPACK FOOTER //
// ./src/logic/util/DateHelper.js